import { render, staticRenderFns } from "./BrowseUserGroups.vue?vue&type=template&id=d4d4662e&scoped=true"
import script from "./BrowseUserGroups.vue?vue&type=script&lang=js"
export * from "./BrowseUserGroups.vue?vue&type=script&lang=js"
import style0 from "./BrowseUserGroups.vue?vue&type=style&index=0&id=d4d4662e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d4662e",
  null
  
)

export default component.exports